export const TRIAL_PLAN = "TRIAL"; 
export const PAYMOB_PRO_URL = "https://merchant-advisor.paymob.com/";
export const REMINDER_DAYS_BEFORE = 5;
export const PAYMOB_PRO_DEEP_LINK = "/paymob-pro";
export const SUBSCRIBED = "subscribed";
export const UNSUBSCRIBED = "unsubscribed";

export const PAYMOB_PRO_PRICES = [
	{
		monthly: { ae_price: "50" },
		annually: { ae_price: "400" },
	},
	{
		monthly: { ae_price: "120" },
		annually: { ae_price: "1000" },
	},
	{
		monthly: { ae_price: "250" },
		annually: { ae_price: "2100" },
	},
];
